export const POS_TASK_HEADER_CONFIG = {
  titleKey: 'display_title',
  cards: [
    {
      icon: 'barcode_scanner',
      label: 'Código:',
      valueKey: 'short_uuid'
    },
    {
      icon: 'assignment',
      label: 'Tipo:',
      valueKey: 'display_task_type',
      filled: true
    },
    {
      icon: 'event',
      label: 'Inicio:',
      valueKey: 'display_start_date'
    },
    {
      icon: 'event_busy',
      label: 'Final:',
      valueKey: 'display_end_date'
    }
  ]
}

export const POS_TASK_STATUS_UI_MAP = {
  active: { label: 'ACTIVA', statusKey: 'active' },
  unstarted: { label: 'NO INICIADA', statusKey: 'unstarted' },
  expired: { label: 'EXPIRADA', statusKey: 'expired' },
  suspended: { label: 'SUSPENDIDA', statusKey: 'suspended' },
  completed: { label: 'COMPLETADA', statusKey: 'completed' }
}

export const POS_DETAILS_TAB_VALUE = 'pos-task-details'

export const POS_DETAILS_TABS = [
  {
    value: POS_DETAILS_TAB_VALUE,
    label: 'Tareas en PDV',
    icon: 'checklist',
    iconSize: 20,
    filled: true
  }
]

export const POS_DETAILS_TEXTS = {
  loading: 'Cargando...',
  notFound: 'No se encontró la tarea',
  createdSuccessfully: 'La tarea en punto de venta fue creada exitosamente',
  headerTitlePrefix: 'Tareas en punto de venta:',
  statusLabel: 'Estado:',
  emptyStatus: '-',
  discardChangesTitle: '¿Continuar sin guardar?',
  discardChangesMessage: 'Los cambios editados no serán guardados.',
  discardChangesConfirmLabel: 'Continuar',
  defaultConfirmLabel: 'Aceptar'
}
